import React from 'react';

const servicesData = [
  {
    number: '01',
    iconClass: 'flaticon-24-hours-1', // Update with your actual icon
    title: '24x7 cab service',
    text: 'eTravo cab is committed to providing you with 24x7 support',
  },
  {
    number: '02',
    iconClass: 'flaticon-piggy-bank', // Replace with matching icon
    title: 'Affordable Rates',
    text: 'An affordable rate is available instantly on our cab service',
  },
  {
    number: '03',
    iconClass: 'flaticon-car', // Replace with car icon
    title: 'Door to Door pick up and Drop',
    text: 'When it comes to reliable transfers, eTravo Cabs is the best choice',
  },
  {
    number: '04',
    iconClass: 'flaticon-monitor-1', // Use appropriate icon
    title: 'Hassle Free Booking',
    text: 'Book with ease with our hassle-free booking process',
  },
  {
    number: '05',
    iconClass: 'flaticon-star', // Use proper star icon
    title: 'Top Rated Cab Service',
    text: 'A top-rated taxi service for all your transportation needs',
  },
  {
    number: '06',
    iconClass: 'flaticon-signs', // Use icon for quality/star
    title: 'Cars of quality',
    text: 'In order for a car to be considered a quality one, it must last a long time',
  },
];


const ServicesSection = () => {
  return (
    <section className="services-section-one">
      <div className="auto-container">
        <div className="content-container">
          <div className="sec-title">
            <div className="inner-title-box">
              <h2>
              AWESOME SERVICES FOR CLIENTS

              </h2>
              <h4 className="rotate-title darkcolorrr">Our Services</h4>
            </div>
          </div>

          <div className="row clearfix">
            {servicesData.map((service, index) => (
              <div key={index} className="services-block col-md-4 col-sm-6 col-xs-12">
                <div className="inner-box">
                  <div className="upper-box">
                    <div className="icon-box">
                      <span className={`icon ${service.iconClass}`}></span>
                    </div>
                    <span className="number">{service.number}</span>
                  </div>
                  <div className="lower-box">
                    <h3>
                      <a href="/">{service.title}</a>
                    </h3>
                    <div className="text">{service.text}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
